// extracted by mini-css-extract-plugin
module.exports = {"stats":"CNmt","time":"CNjz","icons":"CNj3","icon":"CNaj","photo":"CNj5","video":"CNj7","music":"CNj9"};